import { io, type Socket } from 'socket.io-client';

let socket: Socket | null = null;

export const isVisible = () => document.visibilityState === 'visible';

/** One socket per tab. The session cookie authenticates it; `visible` lets the server skip pushes for open apps. */
export function connectSocket(): Socket {
  socket?.disconnect();
  socket = io({
    path: '/socket.io',
    withCredentials: true,
    transports: ['websocket', 'polling'],
    reconnectionDelay: 500,
    reconnectionDelayMax: 5000,
    auth: (cb) => cb({ visible: isVisible() }),
  });
  return socket;
}

export function disconnectSocket() {
  socket?.disconnect();
  socket = null;
}

export const getSocket = () => socket;

export function emitAck<T = any>(event: string, data: unknown, timeoutMs = 10000): Promise<T> {
  return new Promise((resolve, reject) => {
    if (!socket?.connected) return reject(new Error('socket_disconnected'));
    socket.timeout(timeoutMs).emit(event, data, (err: Error | null, res: T) => (err ? reject(err) : resolve(res)));
  });
}
